import useUser from '@/hooks/useUser';
import { useState, useCallback } from 'react';
import { useTracking } from 'react-tracking';

export const useOnboardingBanner = () => {
  const { data: user, mutate: mutateUser } = useUser();

  const [isBannerDismissed, setIsBannerDismissed] = useState(
    user.isWatchlistBannerDismissed // For both portfolio and watchlist
  );

  const { trackEvent } = useTracking();

  const handleBannerDismissed = useCallback(() => {
    setIsBannerDismissed(true);
    mutateUser({
      settings: {
        has_dismissed_wl_banner: true,
      },
    });
    trackEvent({
      type: 'track',
      subject: 'dismissFVOnboardingBanner',
      action: 'click',
    });
  }, [mutateUser, trackEvent]);

  return {
    isBannerDismissed,
    handleBannerDismissed,
  };
};
